import { BehaviorSubject } from 'rxjs';
import * as i0 from "@angular/core";
var INDRAPackService = /** @class */ (function () {
    function INDRAPackService() {
        this.packs = new BehaviorSubject([]);
        this.currentPacks = this.packs.asObservable();
        this.packSeat = new BehaviorSubject({});
        this.packSeatSelection = this.packSeat.asObservable();
    }
    INDRAPackService.prototype.addPack = function (value) {
        var currentValue = this.packs.getValue();
        var updatedValue = currentValue.concat([value]);
        this.packs.next(updatedValue);
    };
    INDRAPackService.prototype.changePack = function (value) {
        this.packs.next(value);
    };
    INDRAPackService.prototype.removePack = function (value) {
        var currentValue = this.packs.getValue();
        var updatedValue = currentValue.filter(function (pack) { return pack.passengers[0].codeList[0].code != value.passengers[0].codeList[0].code || pack.flightId != value.flightId; });
        this.packs.next(updatedValue);
    };
    INDRAPackService.prototype.selectSeats = function (value) {
        this.packSeat.next(value);
    };
    INDRAPackService.ngInjectableDef = i0.defineInjectable({ factory: function INDRAPackService_Factory() { return new INDRAPackService(); }, token: INDRAPackService, providedIn: "root" });
    return INDRAPackService;
}());
export { INDRAPackService };
